import axios from 'axios'

class ProfileQuestionnaire {
  constructor() {
    this.baseUrl = '/api/v1/users'
  }

  getAllQuestions() {
    return axios.get(`${this.baseUrl}/profile_questions/`).then((response) => {
      response.data.map((res) => {
        // eslint-disable-next-line dot-notation
        res['answers'] = {}
      })

      return response
    })
  }

  saveAllAnswers(data) {
    return axios.post(`${this.baseUrl}/profile_answers/`, data)
  }
}

export const profileQuestions = new ProfileQuestionnaire()
